import {
  ARTICLE_TYPES,
  AddArticleAction,
  EditArticleAction,
  GetOneArticleAction,
  GetOneArticleSuccessAction,
  GetAllArticlesSuccessAction,
  GetAllArticlesAction,
  SetApiArticleRequestStateAction,
  SetApiArticleRequestErrorAction,
  SetApiArticlesRequestStateAction,
  SetApiArticlesRequestErrorAction,
  ResetArticleAction,
  ResetArticlesAction,
  DeleteArticleAction,
} from './articleTypes';
import { ArticleFilterValues, ArticleGetResponse, ArticleParams, ArticleValues } from '../model/articleModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export const setApiArticleRequestState = (
  apiArticleRequestState: API_REQUEST_STATE,
): SetApiArticleRequestStateAction => ({
  type: ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_STATE,
  payload: {
    apiArticleRequestState: apiArticleRequestState,
  },
});

export const setApiArticleRequestError = (apiArticleRequestError: string): SetApiArticleRequestErrorAction => ({
  type: ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_ERROR,
  payload: {
    apiArticleRequestError: apiArticleRequestError,
  },
});

export const setApiArticlesRequestState = (
  apiArticlesRequestState: API_REQUEST_STATE,
): SetApiArticlesRequestStateAction => ({
  type: ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_STATE,
  payload: {
    apiArticlesRequestState: apiArticlesRequestState,
  },
});

export const setApiArticlesRequestError = (apiArticlesRequestError: string): SetApiArticlesRequestErrorAction => ({
  type: ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_ERROR,
  payload: {
    apiArticlesRequestError: apiArticlesRequestError,
  },
});

export const addArticle = (article: ArticleValues): AddArticleAction => ({
  type: ARTICLE_TYPES.ADD,
  payload: {
    article: article,
  },
});

export const resetArticle = (): ResetArticleAction => ({
  type: ARTICLE_TYPES.RESET,
  payload: null,
});

export const resetArticles = (): ResetArticlesAction => ({
  type: ARTICLE_TYPES.RESET_ALL,
  payload: null,
});

export const editArticle = (params: ArticleParams, article: ArticleValues): EditArticleAction => ({
  type: ARTICLE_TYPES.EDIT,
  payload: {
    article: article,
    params: {
      id: params.id,
    },
  },
});

export const deleteArticle = (params: ArticleParams): DeleteArticleAction => ({
  type: ARTICLE_TYPES.DELETE,
  payload: {
    params: {
      id: params.id,
    },
  },
});
export const getArticle = (params: ArticleParams): GetOneArticleAction => ({
  type: ARTICLE_TYPES.GET_ONE,
  payload: {
    params: {
      id: params.id,
    },
  },
});

export const getAllArticles = (articleFilter: ArticleFilterValues): GetAllArticlesAction => ({
  type: ARTICLE_TYPES.GET_ALL,
  payload: {
    articleFilter: articleFilter,
  },
});

export const getOneArticleSuccess = (article: ArticleGetResponse): GetOneArticleSuccessAction => ({
  type: ARTICLE_TYPES.GET_ONE_SUCCESS,
  payload: {
    article: article,
  },
});

export const getAllArticlesSuccess = (articles: ArticleGetResponse[]): GetAllArticlesSuccessAction => ({
  type: ARTICLE_TYPES.GET_ALL_SUCCESS,
  payload: {
    articles: articles,
  },
});
